import validation from '@/lang/en/validation';
import literals from '@/lang/en/literal';

const messages = {
  ...validation,
  ...literals,
};
export default messages;
